/* eslint-disable no-undef */

import { kf1GetEnvironmentVariables } from 'kfone-frontend-core';
import { MODULE_NAME } from 'model/constants';

// import { kf1AuthenticatedHttpClient } from 'kfone-component-library';

// (() => {
//   try {
//     env = kf1GetEnvironmentVariables(MODULE_NAME);
//     localStorage.setItem("env Success", JSON.stringify(env));
//   } catch (error) {
//     // env = process.env;
//     localStorage.setItem("env Success", JSON.stringify(error));

//   }
// })();

export const ENV_VARS: Record<string, string> = kf1GetEnvironmentVariables(MODULE_NAME);

//Sample API call
// const res = await kf1AuthenticatedHttpClient(config);
